export default {
  props: ['targetId'],
  data() {
    return {
      latestKnownScrollY: 0,
      topness: 1,
    };
  },
  computed: {
    topDist() {
      return this.topness >= 0 ? this.topness : 0;
    },
  },
  mounted() {
    window.addEventListener('scroll', this.onScroll, true);
  },
  methods: {
    onScroll() {
      this.latestKnownScrollY = Math.max(
        window.pageYOffset,
        document.documentElement.scrollTop,
        document.body.scrollTop
      );
      this.topness = (this.$el.offsetTop - Math.floor(this.latestKnownScrollY) / 2) / this.$el.offsetTop;
    },
  },
  render() {
    return this.$scopedSlots.default({
      SFopacity: this.topDist,
    });
  },
};
